export default "module.exports = (async () => {\n  const publicKey = identity.publicKey.armor();\n  return publicKey;\n})();"